import { Counterparty, CounterpartyType } from 'entities/counterparties/model'

export const useParseCounterparty = (counterparty?: Counterparty) => {
    const isCompany = counterparty?.type === CounterpartyType.Company
    const counterpartyProfilePhoto = counterparty?.profilePhoto?.readUrl ?? null

    const counterpartyFullName = `${counterparty?.contact?.surname ?? ''} ${counterparty?.contact?.firstName ?? ''} ${counterparty?.contact?.patronymic ?? ''}`
    const organizationName =
        counterparty?.additionalData?.documents?.organizationName ?? ''
    const counterpartyName = isCompany ? organizationName : counterpartyFullName

    return {
        isCompany,

        counterpartyProfilePhoto,
        counterpartyFullName,

        organizationName,
        counterpartyName,
    }
}
